

























import "reflect-metadata";
import { ProductInfo } from "@/api";
import { Component, Vue, Prop } from "vue-property-decorator";

@Component
export default class Product extends Vue {
  @Prop() productInfo: ProductInfo | undefined;
  @Prop() hasCorrectMessage: boolean | undefined;
}
